function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { scheduleInfoApi, scheduleDeleteApi, scheduleStatusApi, scheduleReplySaveApi, scheduleReplyListApi, scheduleReplyDelApi } from '@/api/user';
import { clientRemindDetailApi } from '@/api/enterprise';
import { configRuleApproveApi } from '@/api/config';
import Tips from '@/utils/tips';
import { toGetWeek } from '@/utils/format';
export default {
  name: 'CrmebOaEntCalendarDetails',
  components: {
    editExamine: function editExamine() {
      return import('@/views/user/examine/components/editExamine');
    },
    messageHandlePopup: function messageHandlePopup() {
      return import('@/components/common/messageHandlePopup');
    },
    recordUpload: function recordUpload() {
      return import('@/views/customer/list/components/recordUpload');
    },
    commentList: function commentList() {
      return import('./commentList');
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      deleteVisible: false,
      dialogShow: false,
      commentShow: false,
      loading: false,
      textarea: '',
      commentList: [],
      parameterData: {
        contract_id: '',
        customer_id: '',
        invoice_id: '',
        bill_id: ''
      },
      completionStatus: '',
      deleteText: 1,
      dateInfo: {},
      reply_id: '',
      // 关联评价id
      extendedProps: {},
      type: '0',
      userId: '',
      info: {},
      detail: {},
      infoId: '',
      commentTitle: '评论',
      formInfo: {
        avatar: '',
        type: 'add',
        show: 1,
        data: {},
        follow_id: 0
      },
      buildData: {}
    };
  },
  mounted: function mounted() {
    this.type = '0';
  },
  methods: {
    // 格式化日期
    getYear: function getYear(val, text) {
      return this.$moment(val).format(text);
    },
    isOk: function isOk() {
      this.completeFn(this.completionStatus);
    },
    openBox: function openBox(data) {
      this.dialogVisible = true;
      this.extendedProps = data;
      if (data) {
        this.dateInfo = {
          start: data.start_time,
          end: data.end_time
        };
        this.getInfo(data);
        this.getReplyList(data);
        this.getWeek();
        this.userId = JSON.parse(localStorage.getItem('userInfo')).id;
      }
    },
    getConfigApprove: function getConfigApprove() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return configRuleApproveApi(0);
            case 2:
              result = _context.sent;
              _this.buildData = result.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getInfo: function getInfo(data) {
      var _this2 = this;
      this.loading = true;
      var info = {
        end_time: data.end_time,
        start_time: data.start_time
      };
      scheduleInfoApi(data.itemId, info).then(function (res) {
        _this2.loading = false;
        res.data.user.forEach(function (item) {
          Object.assign(item, {
            finish: 6
          });
          if (res.data.master.id == item.id) {
            if (res.data.master.id == _this2.userId) {
              item.finish = 1;
            } else {
              item.finish = 1;
            }
          }
        });
        if (res.data.task.length !== 0) {
          res.data.user.forEach(function (item) {
            res.data.task.forEach(function (li) {
              if (item.id == li.uid) {
                item.finish = li.status;
              }
            });
          });
        }
        _this2.info = res.data;
        if ([3, 4].includes(_this2.info.type.id)) {
          _this2.getConfigApprove();
        }
        _this2.infoId = res.data.master.id;
      });
    },
    isShow: function isShow(info) {
      var ids = [];
      if (info.user && info.user.length > 0) {
        info.user.map(function (item) {
          ids.push(item.id);
        });
        return ids.includes(info.master.id);
      }
    },
    // 打开评论
    openComment: function openComment() {
      this.commentTitle = '评论';
      this.commentShow = true;
    },
    commentCancel: function commentCancel() {
      this.commentShow = false;
      this.textarea = '';
    },
    // 删除评论
    commentDel: function commentDel(data) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Tips.confirm({
                message: '你确定要删除这条评论吗？'
              });
            case 2:
              _context2.next = 4;
              return scheduleReplyDelApi(data.id);
            case 4:
              _context2.next = 6;
              return _this3.getReplyList(_this3.extendedProps);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 回复
    replyFn: function replyFn(data, row) {
      var name = row ? row.from_user.name : data.from_user.name;
      this.commentTitle = '回复' + '（' + name + '）';
      this.reply_id = data.id;
      if (row) {
        this.to_uid = row.from_user.id;
      } else {
        this.to_uid = data.from_user.id;
      }
      this.commentShow = true;
    },
    // 提交评论/回复
    commentSubmit: function commentSubmit() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_this4.textarea == '')) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", _this4.$message.error('请填写评论内容'));
            case 2:
              data = {
                schedule_id: _this4.info.id,
                reply_id: _this4.reply_id,
                to_uid: _this4.to_uid,
                content: _this4.textarea,
                start: _this4.dateInfo.start,
                end: _this4.dateInfo.end
              };
              _context3.next = 5;
              return scheduleReplySaveApi(data);
            case 5:
              _context3.next = 7;
              return _this4.getReplyList(_this4.extendedProps);
            case 7:
              _context3.next = 9;
              return _this4.commentCancel();
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 获取评论列表数据
    getReplyList: function getReplyList(data) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var newData, result;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              newData = {
                time: data.start_time + ' - ' + data.end_time,
                schedule_id: data.itemId
              };
              _context4.next = 3;
              return scheduleReplyListApi(newData);
            case 3:
              result = _context4.sent;
              _this5.commentList = result.data;
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 打开合同详情
    openContract: function openContract() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.detail = {
                template_type: 'dealt_money_work',
                link_id: _this6.info.link_id
              };
              _context5.next = 3;
              return _this6.$nextTick();
            case 3:
              _this6.$refs.messageHandlePopup.openMessage(_this6.info);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // 打开客户详情
    openCustomer: function openCustomer() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.detail = {
                template_type: 'dealt_client_work',
                link_id: _this7.info.link_id
              };
              _context6.next = 3;
              return _this7.$nextTick();
            case 3:
              _this7.$refs.messageHandlePopup.openMessage(_this7.info);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    recordChange: function recordChange(val) {
      this.dialogVisible = false;
      if (!val) {
        this.dialogShow = false;
      }
      this.$emit('deleteFn');
    },
    // 修改状态
    putStatus: function putStatus(text, status) {
      var _this8 = this;
      this.completionStatus = status;
      if (this.extendedProps.cid_value == 3 || this.extendedProps.cid_value == 4) {
        if (this.extendedProps.finish == 3) return false;
        var id = this.extendedProps.bill_id.bill_id !== 0 ? this.extendedProps.bill_id.bill_id : this.extendedProps.bill_id.remind_id;
        if (this.extendedProps.bill_id.bill_id == 0) {
          clientRemindDetailApi(id).then(function (res) {
            _this8.parameterData.customer_id = res.data.eid;
            _this8.parameterData.contract_id = res.data.cid;
            if (_this8.extendedProps.cid_value == 4) {
              _this8.$refs.editExamine.openBox(_this8.buildData.contract_refund_switch, res.data.cid, 'contract_refund_switch');
            } else {
              _this8.$refs.editExamine.openBox(_this8.buildData.contract_renew_switch, res.data.cid, 'contract_renew_switch');
            }
          });
        }
      } else if (this.extendedProps.cid_value == 2) {
        if (this.extendedProps.finish == 3) return false;
        this.formInfo.follow_id = this.extendedProps.bill_id ? this.extendedProps.bill_id.follow_id : 0;
        this.formInfo.data.eid = this.extendedProps.link_id;
        this.dialogShow = true;
      } else {
        this.completeFn(status);
      }
    },
    // 任务完成
    completeFn: function completeFn(status) {
      var _this9 = this;
      var data = {
        status: status,
        start: this.dateInfo.start,
        end: this.dateInfo.end
      };
      scheduleStatusApi(this.info.id, data).then(function (res) {
        _this9.dialogVisible = false;
        _this9.$emit('deleteFn');
      }).catch(function (err) {});
    },
    // 删除弹窗
    onDelete: function onDelete() {
      var _this10 = this;
      this.deleteText = 1;
      if (this.info.period == 0) {
        this.$modalSure('确认删除当前日程').then(function () {
          var data = {
            start: _this10.dateInfo.start,
            end: _this10.dateInfo.end,
            type: '2'
          };
          _this10.scheduleDeleteFn(data);
          _this10.dialogVisible = false;
        });
      } else {
        this.dialogVisible = false;
        setTimeout(function () {
          _this10.deleteVisible = true;
        }, 300);
      }
    },
    handleClose: function handleClose() {
      this.deleteVisible = false;
      this.type = '0';
    },
    // 编辑弹窗
    onEdit: function onEdit() {
      var _this11 = this;
      this.deleteText = 2;
      if (this.info.period == 0) {
        this.dialogVisible = false;
        var date = {
          start: this.dateInfo.start,
          end: this.dateInfo.end
        };
        this.type = '2';
        this.$emit('editFn', this.info.id, this.type, date);
      } else {
        this.dialogVisible = false;
        setTimeout(function () {
          _this11.deleteVisible = true;
        }, 300);
      }
    },
    returnFn: function returnFn() {
      var _this12 = this;
      this.deleteVisible = false;
      this.type = '0';
      setTimeout(function () {
        _this12.dialogVisible = true;
      }, 300);
    },
    // 删除
    deleteFn: function deleteFn() {
      var data = {
        start: this.dateInfo.start,
        end: this.dateInfo.end,
        type: this.type
      };
      if (this.deleteText == 1) {
        this.scheduleDeleteFn(data);
      } else {
        var date = {
          start: this.dateInfo.start,
          end: this.dateInfo.end
        };
        this.deleteVisible = false;
        this.$emit('editFn', this.info.id, this.type, date);
      }
    },
    scheduleDeleteFn: function scheduleDeleteFn(data) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return scheduleDeleteApi(_this13.info.id, data);
            case 2:
              _this13.deleteVisible = false;
              _this13.type = '0';
              _context7.next = 6;
              return _this13.$emit('deleteFn');
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getWeek: function getWeek(date) {
      // 参数时间戳

      if (this.$moment(date).format('YYYY-MM-DD') == this.$moment().format('YYYY-MM-DD')) {
        return '今天';
      }
      return toGetWeek(date);
    }
  }
};